import { Injectable, computed, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalLoadingService {
  private activeRequests = signal<number>(0);

  public readonly isLoading = computed(() => this.activeRequests() > 0);

  showLoader(): void {
    this.activeRequests.update(val => val + 1);
  }

  hideLoader(): void {
    this.activeRequests.update(val => Math.max(0, val - 1));
  }
}
